import type {
  PrivacyService,
} from "../types";



interface GoogleAnalyticsOptions {

  measurementId:string;

}



export function googleAnalytics(
 options:GoogleAnalyticsOptions
):PrivacyService {


 return {

  id:"google-analytics",

  name:"Google Analytics 4",

  category:"analytics",

  provider:"Google",


  description:
   "Servizio di analisi statistiche del traffico del sito.",



  cookies:[

    {
      name:"_ga",

      provider:"Google",

      duration:"2 anni",

      purpose:
      "Utilizzato per distinguere gli utenti.",

      category:"analytics"
    },


    {
      pattern:"_ga_*",

      provider:"Google",

      duration:"2 anni",

      purpose:
      "Cookie Google Analytics 4 per la sessione e l'identificazione della proprietà Analytics.",

      category:"analytics"
    },


    {
      name:"_gid",

      provider:"Google",

      duration:"24 ore",

      purpose:
      "Utilizzato per distinguere gli utenti.",

      category:"analytics"
    }

  ],



  scripts:[

   {

    id:"ga4-script",

    src:
    `https://www.googletagmanager.com/gtag/js?id=${options.measurementId}`

   },


   {

    id:"ga4-config",

    code:`

window.dataLayer =
window.dataLayer || [];

function gtag(){
dataLayer.push(arguments);
}

gtag(
'js',
new Date()
);


gtag(
'config',
'${options.measurementId}'
);

`

   }

  ]

 };


}